module.exports = __webpack_public_path__ + "static/media/python.19e43c11.webp";